module.exports = AWS;